import { render, staticRenderFns } from "./AppMultiselectChoices.vue?vue&type=template&id=494f66d4&scoped=true"
import script from "./AppMultiselectChoices.vue?vue&type=script&lang=js"
export * from "./AppMultiselectChoices.vue?vue&type=script&lang=js"
import style0 from "./AppMultiselectChoices.vue?vue&type=style&index=0&id=494f66d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f66d4",
  null
  
)

export default component.exports